// Return a random UUID. "Crypto" doesn't exist everywhere, for instance not during unit tests.
export function randomUUID() {
  // Generated by ChatGPT
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    // Generate a random hexadecimal digit
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
